import { getters } from './getters'
import { mutations } from './mutations'
import { actions } from './actions'

const state = {
  sessionExpired: false,
  profile: {
    init: 0,
    initErr: [],
    menu: {},
    usrId: undefined,
    email: undefined,
    firstName: undefined,
    lastName: undefined,
    mobileNo: undefined,
    officeNo: undefined,
    passwordExpiryDate: undefined,
    usrRefId: undefined,
    mtrQuoteStatusNotify: undefined,
    mtrQuoteStatusMail: undefined,
    mtrQuotePendingNotify: undefined,
    mtrQuotePendingMail: undefined,
    crgoQuoteStatusNotify: undefined,
    crgoQuoteStatusMail: undefined,
    crgoQuotePendingNotify: undefined,
    crgoQuotePendingMail: undefined
  },
  notification: {
    init: 0,
    menu: {},
    newCount: 0,
    notifications: [],
    loadingNewNotification: false,
    hasNext: true,
    lastId: 0
  },
  rptJob: {
    rptProcess: {
      show: false,
      processes: []
    }
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
